/** @param {import('pdfjs-dist').PageViewport} baseViewport */
export function computeFitScale(baseViewport, containerEl, pad = 32) {
  const maxW = Math.max((containerEl?.clientWidth || 680) - pad, 240);
  const maxH = Math.max((containerEl?.clientHeight || 720) - pad, 240);
  const fit = Math.min(maxW / baseViewport.width, maxH / baseViewport.height);
  return Math.max(0.25, Math.min(fit, 2));
}

export function isRasterImageFilename(filename) {
  return /\.(png|jpe?g|gif|webp|bmp|tiff?)$/i.test(String(filename || ""));
}

export function pageViewportLooksLikeRaster(baseViewport) {
  return baseViewport.width > 1100 || baseViewport.height > 1400;
}

export function isRasterLikeSource(originalFilename, baseViewport) {
  if (isRasterImageFilename(originalFilename)) return true;
  if (baseViewport) return pageViewportLooksLikeRaster(baseViewport);
  return false;
}

/** @param {import('pdfjs-dist').PDFDocumentProxy} pdf */
export async function shouldFitRasterInViewer(pdf, originalFilename) {
  if (isRasterImageFilename(originalFilename)) return true;
  const page = await pdf.getPage(1);
  return pageViewportLooksLikeRaster(page.getViewport({ scale: 1 }));
}

/** @param {import('pdfjs-dist').PDFDocumentProxy} pdf */
export async function computeFitScaleForPage(pdf, pageNum, containerEl) {
  const page = await pdf.getPage(pageNum);
  return computeFitScale(page.getViewport({ scale: 1 }), containerEl);
}
